import React, { useEffect, useState } from 'react';
import { Avatar, Typography, Space } from 'antd';
import { useSelector} from "react-redux";
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Constant
import { ROOT_CONSTANT } from '../../../../constants'

const { reduxStoreWrapper } = REDUX_UTIL;
const { Text } = Typography;

const ProfileSidebar = () => {
  const user = useSelector(reduxStoreWrapper("user"));
  const [customerSince, setCustomerSince] = useState(null);

  useEffect(() => {
    if (user && user.createdAt) {
      const createdAtDate = new Date(user.createdAt);
      const year = createdAtDate.getFullYear();
      const month = String(createdAtDate.getMonth() + 1).padStart(2, '0');
      const day = String(createdAtDate.getDate()).padStart(2, '0');
      setCustomerSince(`${year}-${month}-${day}`);
    }
  }, [user]);

  return (
    <div style={{ padding: '4em' }}>
      <Space direction="vertical" size="large" style={{display: 'flex', width: '100%', alignItems: 'center' }}>
        {/* Profile Picture */}
        { user.uroleid === "A" ? (
          <Avatar size={150} src={ROOT_CONSTANT.THEME.LOGO} style={{ padding:'20px' ,backgroundColor: '#4169E1', border: '1px solid #4169E1', display: 'flex', alignItems: 'center', justifyContent: 'center' }} alt="Profile Picture" />
        ) : (
          <Avatar size={150} style={{ backgroundColor: '#F5FBFF', border: '1px solid #4169E1', display: 'flex', alignItems: 'center', justifyContent: 'center'  }}>
            <Text style={{ fontSize: '8rem', color: '#4169E1' }}>{user.name && user.name.trim().charAt(0).toUpperCase()}</Text>
          </Avatar>
        )}
        <Text strong>{user.name}</Text>
        <div>
          {/* Contact */}
          <div style={{ marginBottom: '1rem' }}>
            <Text >Contact</Text>
            <br></br>
            <Text strong>{user.contact}</Text>
          </div>

          {/* Email */}
          <div style={{ marginBottom: '1rem' }}>
            <Text >Email</Text>
            <br></br>
            <Text strong>{user.email}</Text>
          </div>

          {/* Customer Since */}
          <div>
            <Text>Since</Text>
            <br></br>
            <Text strong>{customerSince}</Text>
          </div>
        </div>
      </Space>
    </div>
  )
}

export default ProfileSidebar